<template>
  <!-- <div
    v-if="volumeIsUndefined"
    v-tippy="{ arrow: true, theme: 'green' }"
    content="Parada/Executada"
  >
    <div class="h-2 w-2 rounded-full bg-gray-400"></div>
  </div> -->
  <i
    v-html="$icons.double_arrow_blue"
    v-if="tradingPhase === 'ON_ENTRY'"
    v-tippy="{ arrow: true, theme: 'green' }"
    content="Entrando"
  ></i>
  <i
    v-html="$icons.double_arrow_blue"
    v-else-if="tradingPhase === 'ON_EXIT'"
    v-tippy="{ arrow: true, theme: 'green' }"
    content="Saindo"
  ></i>

  <div
    v-else-if="['ON_WAIT_EXIT', 'ON_WAIT_ENTRY'].includes(tradingPhase)"
    v-tippy="{ arrow: true, theme: 'green' }"
    :content="
      tradingPhase === 'ON_WAIT_EXIT'
        ? 'Aguardando saída'
        : 'Aguardando entrada'
    "
  >
    <div class="bg-ontick-blue-600 h-2 w-2 rounded-full"></div>
  </div>

  <div
    v-else
    v-tippy="{ arrow: true, theme: 'green' }"
    content="Parada/Executada"
  >
    <div class="h-2 w-2 rounded-full bg-gray-400"></div>
  </div>
</template>

<script>
export default {
  props: {
    tradingPhase: {
      type: String,
    },
  },
};
</script>

<style></style>
